<template>
  <div class="pay_dailog" @click.self="close">
      <div class="pay_content">
        <div class="pay_title">
          <div>请选择支付方式：</div>
          <img @click.self="close" src="./close_pay.png">
        </div>
        <div class="pay_item">
          <div v-if="!hide_wx" class="weixin" @click.stop="event_pay_weixin">
            <div class="flex weixin-content">
              <img src="./weixin.png" alt="">
              <div class="pay-font">微信支付</div>
            </div>
          </div>
          <div v-if="!hide_zfb" class="zhifubao" @click.stop="event_pay_zhifubao">
            <div class="flex zhifubao-content">
              <img src="./zhifubao.png">
              <div class="pay-font">支付宝支付</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'payDialog',
  props: {
    // 是否隐藏支付宝支付
    hide_zfb: {
      type: Boolean,
      default: false
    },
    // 是否隐藏微信支付
    hide_wx: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      quantity: 1,
    }
  },
  methods:{
    close () {
      this.$emit('close')
    },
    event_pay_weixin(){
        this.$emit("payType", {
            type: 1,
        })
    },
    event_pay_zhifubao(){
        this.$emit("payType", {
            type: 2,
        })
    }
  }
}
</script>

<style>
@import "./payDailog.css";
</style>